import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["trackingUrl", "trackingIdentifier", "direction"];
import { CUIStack } from 'connect-dot-com-ui-components/Components/CUIStack/CUIStack';
import LoginButton from './LoginButton';
import SignupButton from './SignupButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const LoginSignupButtonsMobile = _ref => {
  let {
      trackingUrl,
      trackingIdentifier,
      direction = 'row'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CUIStack, Object.assign({
    direction: direction
  }, rest, {
    children: [/*#__PURE__*/_jsx(LoginButton, {
      variant: "link",
      color: "CARNABY.regular",
      trackingIdentifier: trackingIdentifier
    }), /*#__PURE__*/_jsx(SignupButton, {
      variant: "primary",
      size: "sm",
      trackingUrl: trackingUrl,
      trackingIdentifier: trackingIdentifier
    })]
  }));
};
export default LoginSignupButtonsMobile;